import {
    FETCH_LOCATIONS_FAILURE,
    FETCH_LOCATIONS_REQUEST,
    FETCH_LOCATIONS_SUCCESS
} from './types';

/**
 *
 * @param {Object} [params]
 * @returns
 */
export const fetchLocationsRequest = (params) => ({
    type: FETCH_LOCATIONS_REQUEST,
    payload: params
});

/**
 *
 * @param {Object} [params]
 * @returns
 */
export const fetchLocationsSuccess = (params) => ({
    type: FETCH_LOCATIONS_SUCCESS,
    payload: params
});

/**
 *
 * @param {string} error
 * @returns
 */
export const fetchLocationsFailure = (error) => ({
    type: FETCH_LOCATIONS_FAILURE,
    error
});
